import {Injectable} from '@angular/core';
import moment from 'moment';
import {CookieService} from "@/app/services/cookie.service";

export type FormatTimeInput = number | string | Date | moment.Moment;

@Injectable({providedIn: 'root'})
export class FormatService {

    private readonly defaultLocale: string;

    constructor(private cookieService: CookieService) {
        this.defaultLocale = moment().locale(false).locale();
    }

    time(input: FormatTimeInput | null, momentFormat = 'LT'): string | null {
        if (input === null) {
            return null;
        }
        const locale = this.cookieService.getI18NLocale();
        const momentTime = toMoment(input);
        try {
            const parsedLocale = momentTime.locale(locale).locale();
            const isInvalidLocale = (parsedLocale === this.defaultLocale) && (!locale.startsWith(parsedLocale));
            if (isInvalidLocale) throw new Error('Invalid locale');
            return momentTime.format(momentFormat);
        } catch (e) {
            console.error('Error formatting date', input, momentFormat, locale);
            return null;
        }
    }

    number(input: number | null, maximumFractionDigits = 0): string | null {
        if (input === null) {
            return null;
        }
        const locale = this.cookieService.getI18NLocale();
        try {
            return new Intl.NumberFormat(locale, {maximumFractionDigits}).format(input);
        } catch (e) {
            console.error('Error formatting number', input, maximumFractionDigits, locale);
            return null;
        }
    }
}

export function toMoment(input: FormatTimeInput): moment.Moment {
    if (typeof input === 'string' || typeof input === 'number') {
        return toMoment(new Date(input));
    } else if (input instanceof Date) {
        return moment(input);
    } else {
        return input;
    }
}

export function flattenDisplayLabel(locale: any, displayLabels: any) {
    const defaultBackupLocale = 'en_US';
    if (displayLabels == null) {
        return '';
    } else if (typeof displayLabels !== 'object') {
        return displayLabels;
    } else if (Object.keys(displayLabels).length === 0) {
        return '';
    }
    if (locale != null) {
        const parts = String(locale).split('-');
        const normalizedLocale = parts.length === 2
            ? `${parts[0].toLowerCase()}_${parts[1].toUpperCase()}`
            : locale;
        if (displayLabels[normalizedLocale] != null) {
            return displayLabels[normalizedLocale];
        }
    }
    if (!!displayLabels[defaultBackupLocale]) {
        return displayLabels[defaultBackupLocale];
    } else {
        return displayLabels[Object.keys(displayLabels)[0]];
    }
}
